import { useState, useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { ESTILO_BOTON_LISTAR_NUEVO, ESTILO_BOTON_MODAL_ACEPTAR } from "../../../utils/const/estilos-const";
import ModalConfirmar from "../../../components/modal-confirmar";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import sinAccesoCard from "../../../components/sin-acceso-card";
// import { Settings } from "feather-icons-react/build/IconComponents";
import { sharedMensajeConfirmacion, sharedNextPage } from "../../../utils/shared-functions";
import { SELECT_HABILITADO_DESHABILITADO } from "../../../utils/const/const-select-habilitado-deshabilitado";
import Select from "react-select";
// import ArrowBack from "../../../components/arrow-back";
import { useTranslation } from "react-i18next";
import { COLOR_VERDE_MAIN } from "../../../utils/const/colors-const";
import ProcessingDialog from "../../../components/processing-dialog";
import ToastComponent from "../../../components/toast-component";
import { deshabilitarTipoCarguio, habilitarTipoCarguio, obtenerListaTipoCarguio } from "../../../api/api-tipo-carguio";
import { STRING_ID_TIPO_USUARIO_WEB, STRING_SUPER_ADMIN, STRING_ID_ROL_USUARIO_WEB } from "../../../utils/const/string-const";
import { obtenerPermisoRolUsuarioWeb } from "../../../api/api-permiso-rol-usuario-web";
import { PAGE_ID } from "../../usuarios/gestionar-rol-usuario-web/pages-const";
import { obtenerListaKanban } from "../../../api/api-kanban";
import ColumnKanban from "../../../components/column_kanban";
import {
  DndContext,
  DragOverlay,
  PointerSensor,
  useSensor,
  useSensors,
  closestCorners,
} from "@dnd-kit/core";
import { Plus } from "lucide-react";

let $ = window.$;

export default function ListarRegistroCamionesPage
  () {
  const idTipoUsuarioWeb = localStorage.getItem(STRING_ID_TIPO_USUARIO_WEB);
  const { t } = useTranslation();
  const history = useHistory();
  const [cargandoPage, setCargandoPage] = useState(true);
  // const [listaElementos, setListaElementos] = useState([]);
  const [modalConfirmarDeshabilitarVisible, setModalConfirmarDeshabilitarVisible] = useState(false);
  const [modalConfirmarHabilitarVisible, setModalConfirmarHabilitarVisible] = useState(false);
  const [elementoSelected, setElementoSelected] = useState(null);
  // const [permisos, setPermisos] = useState(null);
  const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(false);
  const [habilitadoSelected, setHabilitadoSelected] = useState(null);

  const [rowsData, setRowsData] = useState([]);
  const [btnBuscar, setBtnBuscar] = useState(false);
  const [btnNuevo, setBtnNuevo] = useState(false);
  const [btnModificar, setBtnModificar] = useState(false);
  const [btnDeshabilitar, setBtnDeshabilitar] = useState(false);
  const [btnHabilitar, setBtnHabilitar] = useState(false);

  const [listaKanban, setListaKanban] = useState([]);
  const [kanbanColumns, setKanbanColumns] = useState([]);
  const [kanbanTypeToAdd, setKanbanTypeToAdd] = useState(null);
  const [showAddColumnPanel, setShowAddColumnPanel] = useState(false);
  const [activeDragItem, setActiveDragItem] = useState(null);

  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 6 } })
  );

  const [processingVisible, setProcessingVisible] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("warning"); // "warning" | "success" | "error"

  useEffect(() => {
    iniciar();
  }, []);

  const iniciar = async () => {
    let tieneAcceso = false;
    try {
      let objEnviar = {};
      objEnviar.habilitado = habilitadoSelected !== null ? habilitadoSelected.value : null;
      if (idTipoUsuarioWeb === STRING_SUPER_ADMIN) {
        tieneAcceso = true;
        setBtnBuscar(true);
        setBtnNuevo(true);
        setBtnModificar(true);
        setBtnDeshabilitar(true);
        setBtnHabilitar(true);
      }
      if (idTipoUsuarioWeb !== STRING_SUPER_ADMIN) {
        const idRolUsuarioWeb = localStorage.getItem(STRING_ID_ROL_USUARIO_WEB);
        objEnviar.idRolUsuarioWeb = idRolUsuarioWeb;
        const response = await obtenerPermisoRolUsuarioWeb(objEnviar);
        if (response.error === false && response.data !== undefined) {
          const permisos = JSON.parse(response.data.permisos);
          // console.log('permisos');
          // console.log(permisos);
          if (Array.isArray(permisos) && permisos.length > 0) {
            const manage = permisos.find(p => p.id === 8);
            if (manage !== undefined && manage !== null) {
              const permisosPage = manage.subMenu.find(p => p.value === PAGE_ID.TIPO_CARGUIO);
              tieneAcceso = permisosPage.checked;
              if (tieneAcceso === false) {
                return;
              }
              const permisoBtnBuscar = permisosPage.acciones.find(a => a.value === 'btn_buscar');
              const permisoBtnNuevo = permisosPage.acciones.find(a => a.value === 'btn_nuevo');
              const permisoBtnModificar = permisosPage.acciones.find(a => a.value === 'btn_modificar');
              const permisoBtnDeshabilitar = permisosPage.acciones.find(a => a.value === 'btn_deshabilitar');
              const permisoBtnHabilitar = permisosPage.acciones.find(a => a.value === 'btn_habilitar');
              setBtnBuscar(permisoBtnBuscar?.checked);
              setBtnNuevo(permisoBtnNuevo?.checked);
              setBtnModificar(permisoBtnModificar?.checked);
              setBtnDeshabilitar(permisoBtnDeshabilitar?.checked);
              setBtnHabilitar(permisoBtnHabilitar?.checked);
            }
          }
        }
      }
      if (tieneAcceso === true) {
        let lista = [];

        lista = await obtenerListaTipoCarguio(objEnviar, false, t);
        setRowsData(lista);

        const responstListaKanban = await obtenerListaKanban(objEnviar, false, t);
        setListaKanban(responstListaKanban);
      }
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
    } finally {
      setCargandoPage(false);
      setTieneAccesoAlModulo(tieneAcceso);
    }
  };

  /*useEffect(() => {
    // Small delay to ensure DOM is ready
    const timer = setTimeout(() => {
      const gridElement = $("#gridContainer");
      if (gridElement.length) {
        try {
          const gridInstance = gridElement.dxDataGrid("instance");
          if (gridInstance) {
            // Grid already exists, just update the data source
            gridInstance.option("dataSource", rowsData);
          } else {
            // Grid doesn't exist yet, initialize it
            inicializarGrid();
          }
        } catch (e) {
          // Grid doesn't exist yet, initialize it
          inicializarGrid();
        }
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [rowsData]);

  const inicializarGrid = () => {
    try {
      const gridElement = $("#gridContainer");

      // Check if element exists
      if (!gridElement.length) {
        // console.warn("Grid container element not found");
        return;
      }

      // Initialize the grid
      gridElement.dxDataGrid({
        dataSource: rowsData,
        paging: {
          pageSize: 20,
        },
        pager: {
          showPageSizeSelector: true,
          allowedPageSizes: [50, 100, 150, 200],
        },
        remoteOperations: false,
        groupPanel: { visible: true },
        grouping: {
          autoExpandAll: false,
        },
        allowColumnReordering: true,
        rowAlternationEnabled: true,
        showBorders: true,
        columnAutoWidth: true,
        filterRow: {
          visible: true,
          applyFilter: "auto",
        },
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: t("grilla_placeholderbuscar"),
        },
        export: {
          enabled: true,
        },
        headerFilter: {
          visible: true,
        },
        columns: [
          {
            dataField: "acciones",
            caption: t("column_acciones"),
            width: 200,
            allowFiltering: false,
            allowSorting: false,
            cellTemplate: function (container, options) {
              // console.log("cellTemplate acciones");
              // console.log('options', options);
              // console.log('options.data', options.data);
              const buttonContainer = $("<div>").addClass("flex gap-2");
              if (btnModificar === true) {
                // Edit button
                $("<button>")
                  .addClass(
                    "px-3 py-1 bg-blue-500 hover:bg-blue-600 text-white rounded text-sm"
                  )
                  .text(t("column_modificar"))
                  .on("click", function () {
                    modificarElementoSelected(options.data);
                  })
                  .appendTo(buttonContainer);
              }

              if (btnDeshabilitar === true) {
                // Delete button
                if (options.data.habilitado === 1) {
                  $("<button>")
                    .addClass(
                      "px-3 py-1 bg-red-500 hover:bg-red-600 text-white rounded text-sm"
                    )
                    .text(t("column_deshabilitar"))
                    .on("click", function () {
                      cambiarEstadoDeshabilitar(options.data);
                    })
                    .appendTo(buttonContainer);
                }
              }
              if (btnHabilitar === true) {
                if (options.data.habilitado === 0) {
                  $("<button>")
                    .addClass(
                      `px-3 py-1 bg-[${COLOR_VERDE_MAIN}] hover:bg-[#006600] text-white rounded text-sm`
                    )
                    .text(t("column_habilitar"))
                    .on("click", function () {
                      cambiarEstadoHabilitar(options.data);
                    })
                    .appendTo(buttonContainer);
                }
              }

              buttonContainer.appendTo(container);
            },
          },
          {
            dataField: "id",
            caption: "ID",
            visible: false,
          },
          {
            dataField: "codigo",
            caption: t("column_codigo"),
            visible: true,
          },
          {
            dataField: "descripcion",
            caption: t("column_descripcion"),
            visible: true,
          },
          {
            dataField: "nota",
            caption: t("column_nota"),
            width: 150,
          },
          {
            dataField: "fechaProceso",
            caption: t("column_fechaProceso"),
            width: 200,
          },
          {
            dataField: "habilitadoLabel",
            caption: t("column_estado"),
            width: 200,
          }
        ],
      });
    } catch (err) {
      console.error("Error initializing grid:", err);
    }
  };

  const modificarElementoSelected = (data) => {
    try {
      // console.log("modificarElementoSelected");
      // console.log(data);
      if (data.acciones !== undefined) {
        delete data.acciones;
      }
      let obj = {};
      obj.titulo = t("label_modificar_tipo_carguio");
      obj.params = data;
      // console.log('obj');
      // console.log(obj);
      sharedNextPage("tipo-carguio", obj, history);
    } catch (err) {
      console.log("modificarElementoSelected err");
      console.log(err);
    }
  };

  const cambiarEstadoDeshabilitar = async (data) => {
    try {
      // console.log("cambiarEstadoDeshabilitar");
      // console.log(data);
      setElementoSelected(data);
      setModalConfirmarDeshabilitarVisible(true);
    } catch (err) {
      console.log("cambiarEstadoDeshabilitar err");
      console.log(err);
    }
  };

  const cambiarEstadoHabilitar = async (data) => {
    try {
      // console.log("cambiarEstadoHabilitar");
      // console.log(data);
      setElementoSelected(data);
      setModalConfirmarHabilitarVisible(true);
    } catch (err) {
      console.log("cambiarEstadoHabilitar err");
      console.log(err);
    }
  };*/

  const handleNuevoClick = () => {
    // console.log("handleNuevoClick");
    let obj = {};
    let data = {};
    data.id = 0;
    data.codigo = "";
    data.descripcion = "";
    data.nota = "";
    obj.titulo = t("label_crear_registro_camiones");
    obj.params = data;
    sharedNextPage("registro-camiones", obj, history);
  };

  const availableKanbanOptions = useMemo(() => {
    const usedIds = new Set(kanbanColumns.map((col) => col.kanbanType.id));
    return listaKanban
      .filter((k) => !usedIds.has(k.id))
      .map((k) => ({
        value: k.id,
        label: k.descripcion || k.codigo || k.id,
        kanbanType: k,
      }));
  }, [listaKanban, kanbanColumns]);

  const canAddMoreColumns = availableKanbanOptions.length > 0;

  const handleAddKanbanColumn = () => {
    if (!kanbanTypeToAdd?.kanbanType) return;

    const isFirstColumn = kanbanColumns.length === 0;
    const newColumn = {
      columnId: `col-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      kanbanType: kanbanTypeToAdd.kanbanType,
      items: isFirstColumn ? [...rowsData] : [],
    };

    setKanbanColumns((prev) => [...prev, newColumn]);
    setKanbanTypeToAdd(null);
    setShowAddColumnPanel(false);
  };

  const findColumnByItemId = (columns, itemId) =>
    columns.find((col) => col.items.some((item) => String(item.id) === String(itemId)));

  const handleKanbanDragStart = (event) => {
    const { active } = event;
    const sourceColumn = findColumnByItemId(kanbanColumns, active.id);
    const item = sourceColumn?.items.find((i) => String(i.id) === String(active.id));
    if (item) {
      setActiveDragItem(item);
    }
  };

  const handleKanbanDragEnd = (event) => {
    const { active, over } = event;
    setActiveDragItem(null);
    if (!over) return;

    const activeId = String(active.id);
    let targetColumnId = null;

    if (String(over.id).startsWith("column-")) {
      targetColumnId = String(over.id).replace("column-", "");
    } else {
      const overColumn = findColumnByItemId(kanbanColumns, over.id);
      targetColumnId = overColumn?.columnId ?? null;
    }

    if (!targetColumnId) return;

    setKanbanColumns((prev) => {
      const sourceColumn = findColumnByItemId(prev, activeId);
      if (!sourceColumn) return prev;

      const targetColumn = prev.find((col) => col.columnId === targetColumnId);
      if (!targetColumn) return prev;

      if (sourceColumn.columnId === targetColumn.columnId) return prev;

      const movingItem = sourceColumn.items.find((i) => String(i.id) === activeId);
      if (!movingItem) return prev;

      return prev.map((col) => {
        if (col.columnId === sourceColumn.columnId) {
          return {
            ...col,
            items: col.items.filter((i) => String(i.id) !== activeId),
          };
        }
        if (col.columnId === targetColumn.columnId) {
          if (col.items.some((i) => String(i.id) === activeId)) return col;
          return {
            ...col,
            items: [...col.items, movingItem],
          };
        }
        return col;
      });
    });
  };

  const handleKanbanDragCancel = () => {
    setActiveDragItem(null);
  };

  const reset = async () => {
    setCargandoPage(true);
    iniciar();
  };

  const showToast = (message, type = "warning", durationMs = 3000) => {
    setToastMessage(message);
    setToastType(type);
    setToastVisible(true);
    // Auto-hide
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(() => {
      setToastVisible(false);
    }, durationMs);
  };

  /*
  const handleConfirmModalDeshabilitar = async () => {
    setModalConfirmarDeshabilitarVisible(false);
    if (elementoSelected == null) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = elementoSelected.id;
    setProcessingVisible(true);
    if (elementoSelected.id !== 0) {
      // console.log('crear correo');
      const response = await deshabilitarTipoCarguio(objEnviar);
      setProcessingVisible(false);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        showToast(t("alert_se_deshabilito_correctamente"));
        reset();
      }
      if (response.error === true) {
        showToast(response.message, "error", 3000);
      }
    }
  };

  const handleConfirmHabilitarModal = async () => {
    setModalConfirmarHabilitarVisible(false);
    if (elementoSelected == null) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = elementoSelected.id;
    if (elementoSelected.id !== 0) {
      // console.log('crear correo');
      const response = await habilitarTipoCarguio(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        showToast(t("alert_se_habilito_correctamente"), "success", 3000);
        reset();
      }
      if (response.error === true) {
        showToast(response.message, "error", 3000);
      }
    }
  };*/

  const render = () => {
    try {
      // console.log('listar correo render');
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (tieneAccesoAlModulo === false) {
        return sinAccesoCard();
      }
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6">
          <div className="flex items-center justify-between py-4">
            <div>
              <div className="flex items-center gap-2">
                {/* <ArrowBack onClick={handleAtrasClick} /> */}
                <h2 className="text-xl font-bold text-gray-900">{t("label_gestionar_registro_camiones")}</h2>
              </div>
              <p className="text-sm text-gray-500">{t("label_administra_la_lista_de_registro_camiones")}</p>
            </div>
            {btnNuevo && (
              <div className="flex items-center gap-2">
                <button
                  type="button"
                  className={ESTILO_BOTON_LISTAR_NUEVO}
                  onClick={() => {
                    handleNuevoClick();
                  }}
                >
                  {t("label_nuevo")}
                </button>
              </div>
            )}
          </div>
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
              <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="habilitado">
                {t("label_estado")}
              </label>
              <Select options={SELECT_HABILITADO_DESHABILITADO} isSearchable='true'
                isClearable='true'
                value={habilitadoSelected}
                onChange={(event) => setHabilitadoSelected(event)}
                placeholder={t("placeholder_seleccione_estado")}
              />
            </div>
            {btnBuscar && (
              <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="habilitado">
                  &nbsp;
                </label>
                <button
                  type="button"
                  className={ESTILO_BOTON_MODAL_ACEPTAR}
                  onClick={() => { reset(); }}
                >
                  {t("label_buscar")}
                </button>
              </div>
            )}
          </div>
          <br />
          <div className="bg-white border border-gray-200 rounded-lg p-4">
            <DndContext
              sensors={sensors}
              collisionDetection={closestCorners}
              onDragStart={handleKanbanDragStart}
              onDragEnd={handleKanbanDragEnd}
              onDragCancel={handleKanbanDragCancel}
            >
              <div className="flex gap-4 overflow-x-auto pb-2 items-start">
                {kanbanColumns.map((column) => (
                  <ColumnKanban
                    key={column.columnId}
                    columnId={column.columnId}
                    title={column.kanbanType.descripcion || column.kanbanType.codigo}
                    items={column.items}
                  />
                ))}

                {canAddMoreColumns && (
                  <div className="w-72 shrink-0">
                    {!showAddColumnPanel ? (
                      <button
                        type="button"
                        onClick={() => setShowAddColumnPanel(true)}
                        className="flex flex-col items-center justify-center w-full min-h-[120px] border-2 border-dashed border-gray-300 rounded-lg text-gray-500 hover:border-blue-400 hover:text-blue-600 hover:bg-blue-50/30 transition"
                      >
                        <Plus className="h-6 w-6 mb-1" />
                        <span className="text-sm font-medium">{t("label_agregar_columna")}</span>
                      </button>
                    ) : (
                      <div className="border border-gray-200 rounded-lg p-3 bg-gray-50 space-y-3">
                        <label className="block text-sm font-semibold text-[#0F3457]">
                          {t("label_seleccionar_tipo_columna")}
                        </label>
                        <Select
                          options={availableKanbanOptions}
                          isSearchable
                          isClearable
                          value={kanbanTypeToAdd}
                          onChange={setKanbanTypeToAdd}
                          placeholder={t("placeholder_seleccionar_tipo_kanban")}
                        />
                        <div className="flex gap-2">
                          <button
                            type="button"
                            className="flex-1 px-3 py-2 text-sm border border-gray-300 rounded-md text-gray-700 hover:bg-gray-100"
                            onClick={() => {
                              setShowAddColumnPanel(false);
                              setKanbanTypeToAdd(null);
                            }}
                          >
                            {t("label_cancelar")}
                          </button>
                          <button
                            type="button"
                            className={`flex-1 px-3 py-2 text-sm rounded-md text-white ${kanbanTypeToAdd ? "bg-blue-500 hover:bg-blue-600" : "bg-gray-300 cursor-not-allowed"}`}
                            disabled={!kanbanTypeToAdd}
                            onClick={handleAddKanbanColumn}
                          >
                            {t("label_agregar")}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>

              <DragOverlay>
                {activeDragItem ? (
                  <div className="bg-white border border-blue-300 rounded-lg p-3 shadow-lg w-64 opacity-95">
                    <p className="text-sm font-medium text-gray-900 truncate">
                      {activeDragItem.descripcion ?? activeDragItem.codigo ?? activeDragItem.id}
                    </p>
                  </div>
                ) : null}
              </DragOverlay>
            </DndContext>
          </div>
          {/* Grid Card */}
          {/* <div className="bg-white border border-gray-200 rounded-lg p-2">
            <div className="min-h-[400px]">
              <div
                id="gridContainer"
                style={{
                  height: "100%",
                  width: "100%",
                }}
              />
            </div>
          </div>
          <ModalConfirmar
            isOpen={modalConfirmarDeshabilitarVisible}
            onCancel={() => { setModalConfirmarDeshabilitarVisible(false); }}
            onConfirm={handleConfirmModalDeshabilitar}
            message={sharedMensajeConfirmacion(t("alert_esta_de_deshabilitar"), elementoSelected?.descripcion)}
          />
          <ModalConfirmar
            isOpen={modalConfirmarHabilitarVisible}
            onCancel={() => { setModalConfirmarHabilitarVisible(false); }}
            onConfirm={handleConfirmHabilitarModal}
            message={sharedMensajeConfirmacion(t("alert_esta_de_habilitar"), elementoSelected?.descripcion)}
          /> */}
          <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
          <ToastComponent
            visible={toastVisible}
            message={toastMessage}
            type={toastType}
            onClose={() => setToastVisible(false)}
          />
        </div>
      );
    } catch (err) {
      console.log('ListarRegistroCamiones render err');
      console.log(err);
      return (
        <div><label>{JSON.stringify(err)}</label></div>
      );
    }
  }

  return render();
}
